/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormTextBox from "../../../shared/forms/FormFields/FormTextBox";
import FormInputNumber from "../../../shared/forms/FormFields/FormInputNumber";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import FormClipboardImage from "../../../shared/forms/FormFields/FormClipboardImage";
import FormTextArea from "../../../shared/forms/FormFields/FormTextArea";
import useForm from "../../../shared/forms/useForm";
import { Dialog } from "primereact/dialog";
import { useEffect } from "react";
import { Button } from "primereact/button";
import ExGrid from "../../../shared/Grid/ExGrid";
import ExColumn from "../../../shared/Grid/ExColumn";
import AddButton from "../../../shared/Grid/Buttons/AddButton";
import FieldAutoComplete from "../../../shared/controls/fieldAutoComplete";
import useApiRequisicion from "../../../api/taller/useApiRequisicion";
import FormCalendar from "../../../shared/forms/FormFields/FormCalendar";

const initialValues = {};

const Articulos = ({ requisicionId, visible, onClose, onSaved }) => {
    const api = useApiRequisicion();
    const [submitted, setSubmitted] = useState(false);
    const {
        values: articulos,
        setValues,
        onChange,
        onValidate,
    } = useForm(initialValues);

    useEffect(() => {
        setValues(initialValues);
    }, [visible]);

    const onSave = async () => {
        console.log('guardar')
        setSubmitted(true);
        console.log('guardar')
        const articulosTransformados = articulos.articulos.map(a => ({
            codigo: a.codigo?.descripcion,
            descripcion: a.codigo?.descripcion,
            precio: a.codigo?.precio,
            cantidad: a.cantidad,
            comentarios: a.comentarios,
            categoria: a.categoria ?? 0,
            unidadesMedida: a.codigo?.unidadesMedida?.id ?? 0,
            refaccion: a.codigo?.refaccion,
            fechaCompromiso: a?.fechaCompromiso,
            fechaEntrega: a?.fechaEntrega ?? null,
            evidencia: a.evidencia
                ? {
                    nombre: a.evidencia.nombre,
                      url: a.evidencia.url ?? null
                }
                : null
            }));
        //console.log('articulosTransformados', articulosTransformados);
        await api.agregarArticulos(requisicionId, articulosTransformados);
           
        onSaved();
    };

    const renderFooterModal = () => {
        return (
            <div className="p-1">
                <Button label="Cancelar" onClick={onClose} className="p-button-outlined" />
                <Button label="Guardar" onClick={onSave} type="button" />
            </div>
        );
    }

    return (
        <Dialog header="Nuevos Articulos" visible={visible} style={{ width: '95%' }}
            onHide={onClose} footer={renderFooterModal}>
            <Form columns={2} values={articulos} onChange={onChange} onValidate={onValidate}
                submitted={submitted}>
            <Field field={"articulos"} cols={6} 
                render={({ value, onParentChange, ...props }) => (
                    <ExGrid 
                        {...props} 
                        data={value}
                        onChange={(data) => onParentChange({ articulos: data })}
                        getEntityId={(row) => row._uniqueUid}
                    >
                        <ExColumn 
                            field="codigo" 
                            title="Código Artículo" 
                            source="refacciones"
                            required={true}
                            cellRenderer={({ row, ...props }) => 
                                <FieldAutoComplete
                                {...props}
                                source="refacciones"
                                value={row?.codigo?.nombre}
                                style={{ width: '100%' }}
                                onChange={(refaccion) => {
                                    console.log("Refacción seleccionada:", refaccion);
                                    props.onChange?.({
                                        ...row,
                                           codigo: {
                                            nombre: refaccion.nombre,
                                            id: refaccion.id
                                        },
                                        descripcion: refaccion.nombre,
                                        unidadesMedida: refaccion.unidadDeMedida,
                                        precio: refaccion.precio,
                                        refaccion: refaccion.id
                                                                    
                                    });
                                }}

                            />
                            }
                        />
                        <ExColumn field="descripcion" title="Descripción de Artículo" required={true} width={'15%'}
                            cellRenderer={({ row, ...props }) => (
                                <FormTextBox
                                    {...props}
                                    value={row?.codigo?.descripcion || row?.descripcion}
                                    disabled={true}
                                    style={{ width: '100%' }}
                                />
                            )}
                        />
                          <ExColumn  
                            field="cantidad" 
                            title="Cantidad" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormInputNumber
                                    {...props}
                                    disabled={false}
                                    value={row.cantidad ?? 0}
                                    style={{ width: '100%' }}
                                    onChange={(e) => {
                                        const nuevoValor = e;
                                        props.onChange?.(nuevoValor); 
                                    }}
                                />
                            }
                        />

                  
                        <ExColumn 
                            field="precio" 
                            title="Precio" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                 <FormInputNumber
                                    {...props}
                                    value={row?.codigo?.precio || row?.precio }
                                    disabled={true}
                                    style={{ width: '100%' }}
                                />  
                            }
                        />
                        <ExColumn 
                            field="unidadesMedida" 
                            title="Unidad de Medida" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormDropDown
                                    {...props}
                                    source="unidadesDeMedida"
                                    value={row?.codigo?.unidadesMedida?.id ||  row?.unidadDeMedia?.id}
                                    disabled={true}
                                    style={{ width: '100%' }}
                                />
                            }
                        />

                        <ExColumn 
                            field="categoria" 
                            title="Categoría" 
                            required={true}
                            cellRenderer={({ row, ...props }) => 
                                <FormDropDown
                                    {...props}
                                    value={row?.categoria}
                                    rows={2}
                                    required={true}
                                    source="categoriaRequisicionesArticulos"
                                    style={{ width: '100%' }}
                                    onChange={(e) => {
                                        const nuevoValor = e;
                                        console.log('categoria change', nuevoValor);
                                        props.onChange?.(nuevoValor);                                         
                                    }}                                    
                                />
                            }
                        />                        

                        <ExColumn 
                            field="evidencia" 
                            title="Evidencia" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormClipboardImage disabled={false} style={{ width: '100%' }} {...props} />
                            }
                        />
                         <ExColumn 
                            field="fechaCompromiso" 
                            title="Fecha Compromiso" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormCalendar
                                    {...props}
                                    value={row?.fechaCompromiso}
                                    rows={3}
                                    required={true}
                                      onChange={(e) => {
                                        const nuevoValor = e;
                                        props.onChange?.(nuevoValor); 
                                    }}
                                />
                            }
                        />
                         <ExColumn 
                            field="fechaEntrega" 
                            title="Fecha Entrega" 
                            cellRenderer={({ row, ...props }) => 
                                <FormCalendar
                                    {...props}
                                    value={row?.fechaEntrega}
                                    rows={3}
                                      onChange={(e) => {
                                        const nuevoValor = e;
                                        props.onChange?.(nuevoValor); 
                                    }}
                                />
                            }
                        />
                         <ExColumn 
                            field="comentarios" 
                            title="Comentarios" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormTextArea
                                    {...props}
                                    value={row?.comentarios}
                                    rows={3}
                                    required={true}
                                      onChange={(e) => {
                                        const nuevoValor = e;
                                        props.onChange?.(nuevoValor); 
                                    }}
                                />
                            }
                        />
                        <ExColumn 
                            field={"command"}
                            headerRenderer={({ onAdd }) => <AddButton onAdd={onAdd} />}
                            
                            width={'50px'} 
                        />
                    </ExGrid>
                )}
            />
            </Form>
        </Dialog>
    );
};

export default Articulos;
